import ReduxRootState from '../../model/Redux/ReduxRootSate';
import produce from 'immer';
import ReduxActionInterface from '../../model/ReduxActionInterface';
import Utils from '../../utils/Utils';
import * as AssetPerksActionType from './actionType';
import IAssetPerk from '../../model/AssetModel/IAssetPerk';
import WinnerInterface from '../../model/User/WinnerInterface';

export const ROOT_VALUE_STATE: ReduxRootState = {
    loading: false,
    data: [],
};

export const assetPerksReducer = (state: ReduxRootState = ROOT_VALUE_STATE, action: ReduxActionInterface) => {

    let index: number = -1;

    let userIndex: number = -1;

    switch (action.type) {

        case AssetPerksActionType.ASSET_PERKS_LOADING:
            return {
                ...state,
                loading: true,
            };

        case AssetPerksActionType.ASSET_PERKS_SUCCESS:
            const stateData = state.data.length > 0 ? Utils.removedDuplicateMongoFile(state.data, action.payload.assetPerks) : [];

            let allData: any = stateData.concat(action.payload.assetPerks);

            // Remove duplicates
            let final: any = allData.filter((v: any, i: any, a: any) => a.findIndex((t: any) => (t._id === v._id)) === i)

            return {
                ...state,
                data: final.sort((a: any, b: any) => a.title.localeCompare(b.title)),// Sort by alphabetics order
                loading: false,
            };

        case AssetPerksActionType.ASSET_PERKS_ALL_SUCCESS:

            const allPerks: ReduxRootState = {
                loading: false,
                data: { },
            };
            allPerks.data = { ...state.data };
            if (action.payload.assetPerks && action.payload.assetPerks[0]) {
                allPerks.data[action.payload.assetPerks[0].assetId] = action.payload.assetPerks;
            }

            return allPerks;

        case AssetPerksActionType.ASSET_PERKS_FETCHING:

            const perksObtained = state.data.length > 0 ? Utils.removedDuplicateMongoFile(state.data, action.payload.data) : action.payload.data;
            return {
                ...state,
                data: perksObtained.concat(action.payload.data),
                // data: perksObtained,
                loading: false,
            };

        case AssetPerksActionType.ASSET_PERKS_ATTRIBUTION_STATUS_UPDATE:
            index = state.data.findIndex((assetPerk: IAssetPerk) => assetPerk._id === action.payload.data.userPerk.perk);
            userIndex = state.data[index].users.findIndex((user: WinnerInterface) => user._id === action.payload.data.userId);

            if (index !== -1) {
                return produce(state, (draftState) => {
                    draftState.data[index].users[userIndex].perkState = action.payload.data.userPerk.state;
                    draftState.loading = false;
                });
            }
            return state;

        case AssetPerksActionType.ASSET_PERKS_ERROR:

            return {
                ...state,
                loading: false,
            };

        default:
            return state;
    }
};
